import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { ErrorState } from '@/components/ui/ErrorState';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { ROUTES } from '@/lib/constants/routes';
import { useDirectory } from '../hooks/useTrustedPartners';
import { DIRECTORY_PREVIEW_COUNT, TRUSTED_PARTNERS_STRINGS as S } from '../trusted-partners.constants';
import { PartnerGrid } from './PartnerGrid';

/** Partner Directory preview on the Trusted Partners page: the first six, then "View All Partners" (FR-111). */
export function DirectorySection() {
  const query = useDirectory({ page: 1, pageSize: DIRECTORY_PREVIEW_COUNT });
  const partners = query.data?.data ?? [];

  return (
    <section className="rounded-card bg-white p-6 shadow-card" aria-labelledby="directory-heading">
      <h2 id="directory-heading" className="mb-4 text-p4 font-semibold text-navy">
        {S.DIRECTORY_HEADING}
      </h2>
      {query.isPending && (
        <div className="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      )}
      {query.isError && <ErrorState description={S.DIRECTORY_LOAD_FAILED} onRetry={() => void query.refetch()} />}
      {query.isSuccess && partners.length === 0 && (
        <EmptyState title={S.DIRECTORY_EMPTY_TITLE} description={S.DIRECTORY_EMPTY_DESCRIPTION} />
      )}
      {query.isSuccess && partners.length > 0 && (
        <>
          <PartnerGrid partners={partners} />
          <div className="mt-6 flex justify-center">
            <Button asChild variant="outline" className="px-6! py-2! text-sm">
              <Link to={ROUTES.TRUSTED_PARTNERS_DIRECTORY}>{S.VIEW_ALL_PARTNERS}</Link>
            </Button>
          </div>
        </>
      )}
    </section>
  );
}
